<template>
  <div class="god-code-list-page">
    <div class="global-header-wrap">
      <div class="god-code-header-left">
        <div class="left-part">
          <span>用户Code</span>
          <div class="listSearch">
            <el-input
              v-model="code"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>应用包名</span>
          <div class="listSearch">
            <el-input
              v-model="pkg"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>应用名称</span>
          <div class="listSearch">
            <el-input
              v-model="name"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>推荐状态</span>
          <div class="listSearch">
            <el-select
              v-model="isRecommended"
              clearable
              @change="search"
              placeholder="请选择"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="已推荐" value="true"></el-option>
              <el-option label="未推荐" value="false"></el-option>
            </el-select>
          </div>
        </div>
        <div class="left-part">
          <span>排序方式</span>
          <div class="listSearch">
            <el-select
              v-model="sortBy"
              @change="handleSortChange"
              placeholder="请选择排序方式"
            >
              <el-option label="创建时间" value="createdAt"></el-option>
              <el-option label="下载次数" value="downloadCount"></el-option>
              <el-option label="查看次数" value="viewCount"></el-option>
            </el-select>
          </div>
        </div>
        <div class="left-part">
          <span>排序方向</span>
          <div class="listSearch">
            <el-button
              @click="toggleOrderBy"
              icon="el-icon-sort"
              size="small"
            >
              {{ orderBy === -1 ? '降序' : '升序' }}
            </el-button>
          </div>
        </div>
        <button class="global-button-style" @click="search()">
          {{ $t("commonMsg.search") }}
        </button>
        <button
          class="global-button-style"
          style="margin-left: 10px"
          @click="getStatistics"
        >
          查看统计
        </button>
        <button
          class="global-button-style"
          style="margin-left: 10px"
          @click="batchDelete"
          :disabled="selectedItems.length === 0"
        >
          批量删除 {{ selectedItems.length > 0 ? `(${selectedItems.length})` : '' }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">大神码总数：{{ total ? total : 0 }}</div>
      <div class="global-body-wrap">
        <AppTable
          ref="appTable"
          :tableProps="tableProps"
          :tableData="tableData"
          :selectCtrl="true"
          @tableHandle="tableHandle"
          @tableSelection="handleSelectionChange"
        />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
        @pageSize="pageSize"
      />
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog
      title="大神码详情"
      :visible.sync="detailDialogVisible"
      width="60%"
    >
      <div v-if="currentDetail" class="detail-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">应用名称:</span>
              <span class="value">{{ currentDetail.name }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">应用包名:</span>
              <span class="value">{{ currentDetail.pkg }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">大神码:</span>
              <span class="value code-value">{{ currentDetail.code }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">用户ID:</span>
              <span class="value">{{ currentDetail.uid || "-" }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">下载次数:</span>
              <span class="value">{{ currentDetail.downloadCount || 0 }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">查看次数:</span>
              <span class="value">{{ currentDetail.viewCount || 0 }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">推荐状态:</span>
              <span class="value">{{
                currentDetail.isRecommended ? "已推荐" : "未推荐"
              }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">状态:</span>
              <span class="value">{{
                currentDetail.status === 0 ? "正常" : "已禁用"
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="detail-item">
              <span class="label">支持型号:</span>
              <span class="value">{{
                currentDetail.model && currentDetail.model.length > 0
                  ? currentDetail.model.join(", ")
                  : "-"
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">创建时间:</span>
              <span class="value">{{
                formatDate(currentDetail.createdAt)
              }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">更新时间:</span>
              <span class="value">{{
                formatDate(currentDetail.updatedAt)
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="currentDetail.config">
          <el-col :span="24">
            <div class="detail-item">
              <span class="label">配置内容:</span>
              <pre class="config-content">{{ currentDetail.config }}</pre>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="currentDetail.sameConfigs && currentDetail.sameConfigs.length > 0">
          <el-col :span="24">
            <div class="detail-item">
              <span class="label">相同配置的其他Code:</span>
              <span class="value">{{ currentDetail.sameConfigs.join(", ") }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 统计信息弹窗 -->
    <el-dialog
      title="大神码统计"
      :visible.sync="statisticsDialogVisible"
      width="800px"
    >
      <div v-if="statistics" class="statistics-content">
        <el-row :gutter="20" class="stats-summary">
          <el-col :span="8">
            <div class="stat-item">
              <div class="stat-label">总数</div>
              <div class="stat-value">{{ statistics.total }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="stat-item">
              <div class="stat-label">推荐数</div>
              <div class="stat-value">{{ statistics.recommended }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="stat-item">
              <div class="stat-label">用户数</div>
              <div class="stat-value">{{ statistics.totalUsers }}</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="12">
            <h4>应用Top10</h4>
            <el-table :data="statistics.byApp" border size="small">
              <el-table-column prop="pkg" label="应用包名"></el-table-column>
              <el-table-column prop="count" label="数量" width="80"></el-table-column>
            </el-table>
          </el-col>
          <el-col :span="12">
            <h4>用户Top10</h4>
            <el-table :data="statistics.byUser" border size="small">
              <el-table-column prop="uid" label="用户ID"></el-table-column>
              <el-table-column prop="count" label="数量" width="80"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statisticsDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";

export default {
  name: "godCode",
  components: {
    AppTable,
    Pagination,
  },
  computed: {
    ...mapGetters(["addPopup"]),
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: "应用名称",
        },
        {
          prop: "pkg",
          label: "应用包名",
        },
        {
          prop: "code",
          label: "大神码",
          width: 100,
        },
        {
          prop: "model",
          label: "支持型号",
          width: 150,
        },
        {
          prop: "downloadCount",
          label: "下载次数",
          width: 100,
        },
        {
          prop: "viewCount",
          label: "查看次数",
          width: 100,
        },
        {
          prop: "recommendStatus",
          label: "推荐状态",
          width: 100
        },
        {
          prop: "statusText",
          label: "状态",
          width: 80
        },
        {
          prop: "createdAt",
          label: "创建时间",
          width: 180,
        },
        {
          prop: "handle",
          label: "操作",
          width: 300,
          btn: [
            this.$t("commonMsg.checkDetails"),
            "推荐",
            "状态",
            this.$t("commonMsg.del"),
          ],
        },
      ];
      return tableProps;
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      code: "",
      pkg: "",
      name: "",
      isRecommended: "",
      sortBy: "createdAt",
      orderBy: -1,
      paramsList: { limit: 20, page: 1, sortBy: "createdAt", orderBy: -1, type: 1 },
      timer: null,
      detailDialogVisible: false,
      currentDetail: null,
      statisticsDialogVisible: false,
      statistics: null,
      selectedItems: [],
    };
  },
  methods: {
    async getGodCodeList() {
      try {
        let res = await this.$http.getGodCodeList(this.paramsList);
        this.total = res.data.count;
        
        this.tableData = res.data.results.map(item => {
          return {
            ...item,
            id: item._id, // AppTable 组件需要 id 字段来进行选择
            model: Array.isArray(item.model) && item.model.length > 0
              ? item.model.join(", ")
              : "-",
            statusText: item.status === 0 ? "正常" : "已禁用",
            recommendStatus: item.isRecommended ? "已推荐" : "未推荐",
            statusBtnText: item.status === 0 ? "禁用" : "启用"
          };
        });
        
        // 清空选中状态
        this.selectedItems = [];
        
        // 清空表格内部的选中状态
        this.$nextTick(() => {
          if (this.$refs.appTable && this.$refs.appTable.$refs.appTable) {
            this.$refs.appTable.$refs.appTable.clearSelection();
            // 同时清空 AppTable 组件内部的选中数据
            this.$refs.appTable.selectDataIds = [];
            this.$refs.appTable.selectData = [];
          }
        });
      } catch (error) {
        console.error(error);
      }
    },

    search() {
      this.paramsList.page = 1;
      this.code
        ? (this.paramsList.code = this.code)
        : delete this.paramsList.code;
      this.pkg ? (this.paramsList.pkg = this.pkg) : delete this.paramsList.pkg;
      this.name ? (this.paramsList.name = this.name) : delete this.paramsList.name;
      this.isRecommended
        ? (this.paramsList.isRecommended = this.isRecommended)
        : delete this.paramsList.isRecommended;

      this.getGodCodeList();
    },

    inputHandleSeach() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.search();
      }, 1000);
    },

    handleSortChange(value) {
      this.paramsList.sortBy = value;
      this.paramsList.page = 1;
      this.getGodCodeList();
    },

    toggleOrderBy() {
      this.orderBy = this.orderBy === -1 ? 1 : -1;
      this.paramsList.orderBy = this.orderBy;
      this.paramsList.page = 1;
      this.getGodCodeList();
    },

    async tableHandle(obj) {
      const row = obj.data.row;
      const type = obj.type;

      if (type === this.$t("commonMsg.checkDetails")) {
        await this.showDetail(row._id);
      } else if (type === "推荐") {
        if (row.isRecommended) {
          this.$confirm("确定要取消推荐此大神码吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            await this.unrecommendGodCode(row._id);
          });
        } else {
          this.$confirm("确定要推荐此大神码吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            await this.setRecommend(row._id);
          });
        }
      } else if (type === "状态") {
        const newStatus = row.status === 0 ? 1 : 0;
        const action = newStatus === 1 ? "禁用" : "启用";
        this.$confirm(`确定要${action}此大神码吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await this.toggleStatus(row._id, newStatus);
        });
      } else if (type === this.$t("commonMsg.del")) {
        this.$confirm("确定要删除此大神码吗?删除后不可恢复！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await this.deleteGodCode(row._id);
        });
      }
    },

    async showDetail(id) {
      try {
        let res = await this.$http.getGodCodeDetail(id);
        this.currentDetail = res.data;
        
        // 获取相同配置的其他code
        try {
          let sameRes = await this.$http.findSameGodCode(id);
          this.currentDetail.sameConfigs = sameRes.data || [];
        } catch (e) {
          this.currentDetail.sameConfigs = [];
        }
        
        this.detailDialogVisible = true;
      } catch (error) {
        this.elMsg("获取详情失败", "error");
      }
    },

    async setRecommend(id) {
      try {
        await this.$http.recommendGodCode(id, {});
        this.getGodCodeList();
        this.elMsg("设置推荐成功", "success");
      } catch (error) {
        this.elMsg("设置推荐失败", "error");
      }
    },

    async unrecommendGodCode(id) {
      try {
        await this.$http.unrecommendGodCode(id);
        this.getGodCodeList();
        this.elMsg("取消推荐成功", "success");
      } catch (error) {
        this.elMsg("取消推荐失败", "error");
      }
    },

    async toggleStatus(id, status) {
      try {
        await this.$http.toggleGodCodeStatus(id, { status });
        this.getGodCodeList();
        this.elMsg(
          status === 0 ? "启用成功" : "禁用成功",
          "success"
        );
      } catch (error) {
        this.elMsg(
          status === 0 ? "启用失败" : "禁用失败",
          "error"
        );
      }
    },

    async deleteGodCode(id) {
      try {
        await this.$http.deleteGodCode(id);
        this.elMsg("删除成功", "success");
        this.getGodCodeList();
      } catch (error) {
        this.elMsg("删除失败", "error");
      }
    },

    async getStatistics() {
      try {
        let res = await this.$http.getGodCodeStatistics();
        this.statistics = res.data;
        this.statisticsDialogVisible = true;
      } catch (error) {
        this.elMsg("获取统计信息失败", "error");
      }
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleString("zh-CN");
    },

    handleSelectionChange(obj) {
      this.selectedItems = obj.data;
    },

    async batchDelete() {
      if (this.selectedItems.length === 0) {
        this.elMsg("请先选择要删除的大神码", "warning");
        return;
      }

      this.$confirm(
        `确定要删除选中的 ${this.selectedItems.length} 个大神码吗？删除后不可恢复！`,
        "批量删除确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(async () => {
        try {
          const deleteCount = this.selectedItems.length;
          const deletePromises = this.selectedItems.map(item => 
            this.$http.deleteGodCode(item._id)
          );
          
          await Promise.all(deletePromises);
          
          this.elMsg(
            `成功删除 ${deleteCount} 个大神码`,
            "success"
          );
          this.getGodCodeList();
        } catch (error) {
          console.error(error);
          this.elMsg("批量删除失败，部分项可能未删除", "error");
          this.getGodCodeList();
        }
      }).catch(() => {
        // 用户取消删除
      });
    },

    pageNum(val) {
      this.paramsList.page = val;
      this.getGodCodeList();
    },

    pageSize(size) {
      this.paramsList.limit = size;
      this.getGodCodeList();
    },
  },
  mounted() {
    this.getGodCodeList();
  },
};
</script>

<style lang="scss" scoped>
.global-header-wrap {
  padding: 10px 44px;
}
.global-button-style {
  margin-top: 20px;
  margin-left: 0;
}
.god-code-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .app-table-container {
    flex: 1;
    overflow: hidden;
  }
  
  .global-body-wrap {
    height: calc(100vh - 320px);
    
    #table-wrap {
      height: 100%;
    }
  }
  
  .god-code-header-left {
    width: 100%;
    float: left;
  }
  .left-part {
    float: left;
    margin-right: 20px;
    .listSearch {
      .el-input {
        width: 180px;
        .search-icon {
          font-size: 22px;
          cursor: pointer;
        }
      }
      .el-select {
        width: 180px;
      }
    }
    > span {
      margin-right: 10px;
      font-size: 14px;
    }
    .global-button-style {
      margin: 0;
    }
  }
}

.detail-content {
  .detail-item {
    margin-bottom: 15px;
    display: flex;
    align-items: flex-start;
    .label {
      font-weight: bold;
      min-width: 100px;
      color: #606266;
    }
    .value {
      flex: 1;
      color: #303133;
      &.code-value {
        font-size: 16px;
        font-weight: bold;
        color: #409EFF;
      }
    }
    .config-content {
      flex: 1;
      background: #f5f7fa;
      padding: 10px;
      border-radius: 4px;
      max-height: 300px;
      overflow: auto;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
}

.statistics-content {
  .stats-summary {
    .stat-item {
      text-align: center;
      padding: 20px;
      background: #f5f7fa;
      border-radius: 4px;
      .stat-label {
        font-size: 14px;
        color: #909399;
        margin-bottom: 10px;
      }
      .stat-value {
        font-size: 28px;
        font-weight: bold;
        color: #409EFF;
      }
    }
  }
  h4 {
    margin-bottom: 10px;
    color: #303133;
  }
}
</style>
